const isoDate = date => [date.getFullYear(), String(date.getMonth() + 1).padStart(2, "0"),
    String(date.getDate()).padStart(2, "0")].join("-");

export const todayDate = () => isoDate(new Date());

export function reportingPreset(preset, today = todayDate()) {
    const date = new Date(`${today}T12:00:00`);
    if (preset === "month") date.setDate(1);
    else date.setDate(date.getDate() - (preset === "30" ? 29 : 6));
    return {from: isoDate(date), to: today};
}

export function validReportingDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || value < "0001-01-01") return false;
    const date = new Date(`${value}T12:00:00Z`);
    return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value;
}

export function reportingError({from, to, limit}, today = todayDate()) {
    if (!validReportingDate(from) || !validReportingDate(to) || from > to || to > today)
        return "DistributorAnalyticsInvalidDates";
    if (!/^\d+$/.test(String(limit)) || Number(limit) < 1 || Number(limit) > 50) return "AnalyticsLimitInvalid";
    return null;
}

export function rankedProducts(data, metric) {
    const key = metric === "SALES_AMOUNT" ? "totalRevenue" : "totalCount";
    // Missing metrics stay visible at the bottom of the table, never becoming invented zeroes.
    return [...data].sort((a, b) => String(a.currency || "ZZZ").localeCompare(String(b.currency || "ZZZ")) ||
        (Number.isFinite(b[key]) ? b[key] : -Infinity) - (Number.isFinite(a[key]) ? a[key] : -Infinity));
}
